app.ContactUs = (
    function () {
        var contactUs = {
            Init: function(inputMessage) {

            //    app.ContactUs.ReCaptcha();

            //    var followUpMessage = "";
            //    if (inputMessage != null && inputMessage.length > 0) {
            //        followUpMessage = inputMessage;
            //    }

            //    if (followUpMessage.length > 0) {
            //        $(".form-row").removeClass("hidden").addClass("hidden");
            //    }

            //    $("#selected-issue").change(function() {
            //        if ($("#selected-issue option:selected").text() === "Feature Request - Employer User") {
            //            $("#feature-message").removeClass("hidden");
            //        } else {
            //            $("#feature-message").removeClass("hidden").addClass("hidden");
            //        }
            //    });

            //    var encodedMailto = "";
            //    $("#txtFirstName, #txtLastName, #txtEmail, #selected-issue, #issue-description").on("keyup change",
            //        function () {
            //            var firstName = $("#txtFirstName").val();
            //            var lastName = $("#txtLastName").val();
            //            var subject = "[" + $("#selected-issue option:selected").text() + "] " + firstName;
            //            if (lastName != null && lastName !== "") {
            //                subject = subject + " " + lastName;
            //            }
            //            var userEmail = $("#txtEmail").val();
            //            var issueDescription = $("#issue-description").val();

            //            // generate mailto link
            //            var mailto = "mailto:" + $("#hdnSupportEmail").val() + "?subject=" + subject + "&body=";
            //            if (userEmail != null && userEmail !== "") {
            //                mailto = mailto + "WECAN Email: " + userEmail + "\r\n\r\n";
            //            }
            //            mailto = mailto + issueDescription;

            //            encodedMailto = encodeURI(mailto);
            //        });

            //    $("#btnContinue").on("click",
            //        function () {
            //            var form = $("#frmEmail");

            //            //validate form
            //            $.validator.unobtrusive.parse(form);
            //            if (form.valid()) {
            //                $("#lnkMailto").attr("href", encodedMailto);

            //                // trigger with a click() instead of changing the href
            //                // because we want to stay on the same page
            //                $("#lnkMailto")[0].click();
            //                toastr.success("Success! Please continue in your email client.");
            //            } else {
            //                toastr.error("Please fix errors before continuing.");
            //            }
            //        });


            }

            //ReCaptcha: function() {
            //    var reCaptchaSiteKey = $("#GoogleCaptchaToken").data("recaptcha-site-key");
            //    grecaptcha.ready(function() {
            //        grecaptcha.execute(reCaptchaSiteKey, { action: "submit" }).then(function(token) {
            //            $("#GoogleCaptchaToken").val(token);
            //        });
            //    });
            //}
        };

        return contactUs;
    }()
);